/**
 * GOP LENH ANH TRUOC KHI GHI.
 *
 * Tach rieng khoi PdfCoreBrowser vi day la mot ham THUAN TUY tren danh sach
 * lenh - khong cham vao pdf.js, khong cham vao pdf-lib - va bo test phai goi
 * duoc no ma khong keo theo ca mot worker pdf.js.
 */
import type { EditCommand } from '@pdfeditor/types';
import type { ImageContentEdit } from './imageEdit';

/**
 * MOT LENH ANH CO PHAI THU DUONG GHI CUA BAN WEB LAM DUOC KHONG.
 *
 * Ton tai vi mot ly do rat cu the. Duong xuat tep loc danh sach lenh thanh
 * "ghi duoc" va "bo qua", va cai loc do liet ke TUNG loai lenh mot. Them mot
 * loai lenh moi vao hop dong ma quen dong do thi hau qua la thu te nhat co the:
 * nguoi dung keo mot tam anh, thay no dich tren man hinh, xuat tep ra va tam
 * anh van nam cho cu - khong loi, khong canh bao nao noi dung ban chat.
 *
 * Gom vao mot ham canh chinh phep gop lenh anh de hai thu doc cung mot danh
 * sach, thay vi hai chuoi dieu kien o hai tep khac nhau phai nho nhau.
 */
export function isImageContentCommand(command: EditCommand): boolean {
  return command.kind === 'content.image.transform' || command.kind === 'content.image.remove';
}

/**
 * GOP CAC LENH ANH THANH MOT THAO TAC DUY NHAT CHO MOI ANH.
 *
 * Bat buoc, khong phai toi uu. Duong ghi la CAT VA NOI tren day byte: hai lenh
 * cung sua vao mot toan tu cm se cho ra hai phep cat chong nhau, va
 * applyImageContentEdits() tu choi ca cum do (dung the - cat chong nhau la mot
 * luong hong). Ma mot cu keo chuot sinh ra hang chuc lenh transform.
 *
 * Quy tac: voi moi (trang, lan ve anh), lenh XOA thang moi lenh khac; con lai
 * thi lenh CUOI CUNG thang. Do dung la ngu nghia nguoi dung mong doi - trang
 * thai cuoi cung cua anh la thu ho dang nhin thay.
 */
export function collapseImageEdits(
  commands: readonly EditCommand[],
): Map<number, ImageContentEdit[]> {
  const byKey = new Map<string, { pageIndex: number; edit: ImageContentEdit }>();
  for (const command of commands) {
    if (command.kind === 'content.image.transform') {
      const key = String(command.pageIndex) + ':' + String(command.occurrence);
      const existing = byKey.get(key);
      if (existing && existing.edit.kind === 'remove') continue;
      byKey.set(key, {
        pageIndex: command.pageIndex,
        edit: { kind: 'transform', occurrence: command.occurrence, matrix: command.matrix },
      });
    } else if (command.kind === 'content.image.remove') {
      byKey.set(String(command.pageIndex) + ':' + String(command.occurrence), {
        pageIndex: command.pageIndex,
        edit: { kind: 'remove', occurrence: command.occurrence },
      });
    }
  }

  const out = new Map<number, ImageContentEdit[]>();
  for (const entry of byKey.values()) {
    const list = out.get(entry.pageIndex) ?? [];
    list.push(entry.edit);
    out.set(entry.pageIndex, list);
  }
  return out;
}
